import React from "react";

interface ShimmerTextProps {
  text: string;
  className?: string;
}

export function ShimmerText({ text, className = "" }: ShimmerTextProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={`inline-block bg-clip-text ${className}`}
      style={{
        background:
          "linear-gradient(90deg, var(--fg2) 0%, var(--fg2) 35%, var(--fg3) 50%, var(--fg2) 65%, var(--fg2) 100%)",
        backgroundSize: "200% 100%",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        animation: "shimmer 2s ease-in-out infinite",
      }}
    >
      {text}
    </span>
  );
}
